<div *ngIf="showUpgrade" class="flex flex-col gap-2 justify-between h-full"
    [ngClass]="[isExpanded ? 'w-[250px] mobile:w-[100px]' + ' transition-all duration-500 ease-in-out' : 'w-[100px] mobile:w-[70px]' + ' transition-all duration-1000 ease-in-out', height]" (click)='toggleSidebar()'
    (mouseenter)="setSidebarStatus(true)" (mouseleave)="setSidebarStatus(false)">

    <div
        class="flex-grow bg-neutral-200 bg-opacity-90 flex flex-col items-center justify-center rounded-l-md shadow-lg">
        <div class="text-center p-4 flex flex-col justify-center items-center gap-6">
            <img src="assets/icons/lock-open.svg" class="h-[60px] w-[60px]" alt="{{ 'shared.lock_icon' | transloco }}">
            @if(isExpanded) {
            <p class="mobile:text-sm">{{ label | transloco }}</p>
            <div class="w-[120px] mobile:text-sm mobile:w-[80px]">
                <app-primary-button buttonText="{{ 'shared.learn_more' | transloco }}"
                    (buttonClick)="openPlansPage()"></app-primary-button>
            </div>}
        </div>
    </div>
    <div *ngIf="showUpgrade && showTextUnder" class="text-sm text-neutral-800 text-center w-full">
        {{ textUnder | transloco }}
    </div>

</div>